export default {
    // 测试\正式
    //apiUrl:  `/sns/mobile`
    // 开发
    apiUrl:  `/sns/mobile`,
    apiUrlShort:  `/sns`
}
